import { render, staticRenderFns } from "./TransTable.vue?vue&type=template&id=6cbd8b04&"
import script from "./TransTable.vue?vue&type=script&lang=js&"
export * from "./TransTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports